import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalStyled = styled(Modal)`
  .ant-modal-footer {
    border-top: unset;
  }
  .ant-modal-header {
    border-bottom: unset;
  }

  .ant-modal-title {
    font-size: 16px;
  }

  .ant-modal-body {
    padding-top: 0px;
  }
`;

export default ModalStyled;
